import { OrderReturnedEntity } from "../../domain/entities/order_returned_entity";
import http from "../../../../plugins/http-common"

export const HttpOrderReturnedRepository = {
  model: OrderReturnedEntity,

  async get_detail_order_returned(order_returned_id) {
    const res = await http.get('shipment/return/detail/' + order_returned_id);

    if(res.data.success != undefined && res.data.success != null){
      return {
        id: res.data.success.arguments.id,
        order_returned: res.data.success.arguments.order_returned,
        unique_order_number: res.data.success.arguments.unique_order_number,
        shipment_number: res.data.success.arguments.shipment_number,
        details: res.data.success.arguments.details.map(item => ({
          ...item,
          total_quantity: item.quantity + item.damaged_product + item.stolen_product
        }))
      }
    }
  },

  async update_detail_order_returned(order_returned_data) {
    const res = await http.patch('shipment/return/detail/update', order_returned_data);
    
    return res;
  }
};